module.exports = __webpack_public_path__ + "static/cabina-de-conductor---grada-de-ingreso-d7990ba8e67a4924e641ebef1c5751f1.jpg";